import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    abhaCreatedList: [],
    abhaCreatedListNew: [],
    AbhaCardsLogs: [],
    ReportList: [],
    DECODEBASEData: [],
    DownloadReport: [],
    totalabhaCreatedList: "",
    totalabhaCreatedListNew: "",
    totalAbhaCardsLogs:"",
    totalAbhaReportsLogs:""
}

export const abhaSlice = createSlice({
    name: 'abhaCreated',
    initialState,
    reducers: {
        setAbhaCreatedList: (state, action) => {
            state.abhaCreatedList = action.payload.list;
            state.totalabhaCreatedList = action.payload.dataLength;
        },
        setAbhaCreatedListNew: (state, action) => {
            state.abhaCreatedListNew = action.payload.list;
            state.totalabhaCreatedListNew = action.payload.dataLength;
        },
        setAbhaCardsLogs: (state, action) => {
            state.AbhaCardsLogs = action.payload.list;
            state.totalAbhaCardsLogs = action.payload.total;
        },
        setReportList: (state, action) => {
            state.ReportList = action.payload.list;
            state.totalAbhaReportsLogs = action.payload.total;
        },
        setAddattachmentApi: (state, action) => {
            state.uploadedAttchment = action.payload;
        },
        setDECODEBASEData: (state, action) => {
            state.DECODEBASEData = action.payload.list;
        },
        setDownloadReport: (state, action) => {
            state.DownloadReport = action.payload.list;
        },
       
    },
})

export const { setAbhaCreatedList,setAbhaCreatedListNew, setReportList, setAddattachmentApi, setFaqDetail, setFaqCategoryList, setFaqCategoryDetail, setAbhaCardsLogs,setDownloadReport,setDECODEBASEData } = abhaSlice.actions

export default abhaSlice.reducer